/* Thrive Ion 8 — homepage interactions.
   Lightweight, dependency-free, respects reduced-motion + per-section toggles.
   Re-initialises on Shopify Theme Editor section load/select events. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.ion-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initCounters(scope) {
    var els = (scope || document).querySelectorAll('[data-count]:not([data-counted])');
    els.forEach(function (el) {
      el.setAttribute('data-counted', '1');
      var target = parseFloat(el.getAttribute('data-count'));
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      if (reduce || isNaN(target)) { el.textContent = target.toFixed(dec); return; }
      var run = function () {
        var start = null, dur = 1400, from = 0;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (from + (target - from) * eased).toFixed(dec);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) { run(); io.disconnect(); } });
        }, { threshold: 0.5 });
        io.observe(el);
      } else { run(); }
    });
  }

  function initSelectors(scope) {
    (scope || document).querySelectorAll('[data-ion-selector]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '1');
      var buttons = root.querySelectorAll('[data-ion-select]');
      function setNode(sel, text, prop, val) {
        var n = root.querySelector(sel); if (!n) return;
        if (text != null) n.textContent = text;
        if (prop) n.style[prop] = val;
      }
      function select(id) {
        buttons.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-ion-select') === id ? 'true' : 'false'); });
        root.querySelectorAll('[data-ion-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-ion-panel') !== id;
        });
        var active = root.querySelector('[data-ion-select="' + id + '"]');
        if (active && active.hasAttribute('data-ph')) {
          var d = active.dataset;
          setNode('[data-ph-value]', d.phValue, 'color', d.phColor);
          setNode('[data-ph-name]', d.phName);
          setNode('[data-ph-use]', d.phUse);
          setNode('[data-ph-orp]', d.phOrp + ' mV', 'color', d.phColor);
          var glow = root.querySelector('[data-ph-glow]');
          if (glow) glow.style.background = 'radial-gradient(circle,' + d.phGlow + ',transparent 68%)';
        }
      }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { select(b.getAttribute('data-ion-select')); });
      });
      var def = root.getAttribute('data-ion-default') || (buttons[0] && buttons[0].getAttribute('data-ion-select'));
      if (def) select(def);
    });
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-ion-carousel]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '1');
      var track = root.querySelector('[data-ion-track]');
      if (!track) return;
      var step = function () { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 22 : 300; };
      var prev = root.querySelector('[data-ion-prev]');
      var next = root.querySelector('[data-ion-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function initSticky(scope) {
    (scope || document).querySelectorAll('[data-ion-sticky]:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '1');
      var anchor = document.querySelector(bar.getAttribute('data-ion-after') || '.ion8-hero');
      function onScroll() {
        var show;
        if (anchor) { show = anchor.getBoundingClientRect().bottom < 0; }
        else { show = window.scrollY > 700; }
        bar.classList.toggle('is-show', show);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initAll(scope) {
    initReveal(scope); initCounters(scope); initSelectors(scope);
    initCarousels(scope); initSticky(scope);
  }

  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
